import { Stack } from '@chakra-ui/react';

import { Asset, AssetClass } from '../../_openapi/portfolio-optimizer';
import { Form } from '../../widgets/Form/Form';
import { FormInput } from '../../widgets/Form/FormInput';
import { FormSelect } from '../../widgets/Form/FormSelect';
import { AssetFormFields } from './AssetFormFields';

export const AssetForm = ({ assetData }: { assetData: Asset }) => {
    const Fields = AssetFormFields[assetData.assetClass];

    return (
        <Form defaultValues={assetData} onSubmit={() => {}}>
            <Stack>
                <FormSelect label="Asset Class" fieldName="assetClass" size="sm" labelWidth="240px" isReadOnly>
                    <option value={AssetClass.BOND}>Bond</option>
                    <option value={AssetClass.EQUITY}>Equity</option>
                    <option value={AssetClass.FUTURES}>Futures</option>
                    <option value={AssetClass.OPTIONS}>Options</option>
                </FormSelect>
                <FormInput label="Security ID" fieldName="sId" isReadOnly size="sm" labelWidth="240px" />
                <Fields />
            </Stack>
        </Form>
    );
};
